import { px } from '../core/px.js';
import { styling } from '../core/styling.js';

const borderRadius = styling({
    $borderRadius: {
        type: 'string | number',
        properties: ['borderRadius'],
        transform: px,
    },
});

export { borderRadius };
//# sourceMappingURL=borderRadius.js.map
